/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { handleNextStep, handleStepBack, setClaimDriver } from '../../../actions/claimSubmitActions';
import { showModalDrivableYesNonRegularDriver } from '../../../actions/modalCallbackActions';
import { RegularDriverDropdownItem } from '../../../interfaces/Claims/claimsInterfaces';
import { IDropdownData } from '../../../interfaces/KPDropdown/KPDropdownInterfaces';
import KPDropdown from '../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';


class FnolStep8Sub1DriverDetails extends React.Component<any, any>  {
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.maskID = this.maskID.bind(this);
        this.handleDriverSelection = this.handleDriverSelection.bind(this);

        this.state = {
        }
    }

    async handleSubmit() {
        if (this.props.claimSubmit.claimDriver.isRegularDriver) {
            await this.props.dispatchHandleNextStep();
        }
        else {
            this.props.handleNonRegularUserModal();
        }
    }

    async handleDriverSelection(e: any) {
        var dropdownSelected = this.props.claimSubmit.driverDropdown.find(x => x.order == Number(e))
        await this.props.dispatchSetClaimDriver(dropdownSelected);
    }

    maskID(idNumber) {
        if (idNumber.length == 13) {
            return '(' + idNumber.substring(0, 6) + "*******)";
           
        }
        else {
            return idNumber;
        }
    }

    public render() {
        let driverDropdownItems = this.props.claimSubmit.driverDropdown as Array<RegularDriverDropdownItem>;
        let driverDropdown= [] as Array<IDropdownData>;
        
        if (driverDropdownItems.length > 0) {
            driverDropdown = driverDropdownItems.map((item) => {
                var tempDropdown: IDropdownData = {
                    description: item.name + ' ' + item.surname + ' ' + this.maskID(item.idNumber),
                    id: String(item.order),
                    image: "",
                    productName : ""
                };
                return tempDropdown;
            });
        }

        var driverType = this.props.claimSubmit.isCar ? "Choose driver" : "Choose rider"
        return (
            <div className="col ssp-container-fnol-drivable ssp-container-fnol-step-header-padding">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-drivable">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/number-' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red-32x32px.svg'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                {this.props.claimSubmit.isCar && <h3>Driver details</h3>}
                                {!this.props.claimSubmit.isCar && <h3>Rider details</h3>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 fnol-steps-info-section-holder">
                        <hr className="hr-minus21px" />
                        <div className="mb-20px">
                            {(this.props.claimSubmit.isCar) && <p className="mb-0px line-height-1-43">Who was driving the car at the time of the incident</p>}
                            {(!this.props.claimSubmit.isCar) && <p className="mb-0px line-height-1-43">Who was riding the motorbike at the time of the incident</p>}
                        </div>
                        <div className="ssp-form">
                            <div className="form-group mb-0px">
                                <KPDropdown id={"claim-driver-dropdwon"}
                                    isImageDropdown={false}
                                    showLabelAfterSelection={true}
                                    showLabelInside={true}
                                    showLabelOutside={false}
                                    isRiskItem={false}
                                    labelAfterSelection={driverType}
                                    title={driverType}
                                    label={driverType}
                                    data={driverDropdown}
                                    handleSelection={(e) => this.handleDriverSelection(e)}
                                    selectedValue={driverDropdown.find(x => x.id == String(this.props.claimSubmit.claimDriver.order))} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 nopa fnol-where-it-happened-buttonholder">
                        <button className="btn btn-solid-red fnol-where-it-happened-button-next" id="btn-info-next" disabled={this.props.claimSubmit.claimDriver == ""} onClick={this.handleSubmit}>Next</button>
                        <button className="btn btn-outline-red fnol-where-it-happened-button-back" id="btn-info-back" onClick={this.props.dispatchHandleStepBack}>Back</button>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHandleNextStep: () => dispatch(handleNextStep()),
        dispatchHandleStepBack: () => dispatch(handleStepBack()),
        handleNonRegularUserModal: () => dispatch(showModalDrivableYesNonRegularDriver()),
        dispatchSetClaimDriver: (data) => dispatch(setClaimDriver(data)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FnolStep8Sub1DriverDetails);